import React from 'react';

import { Form, Button, Col, } from 'react-bootstrap';


const DEFAULT_DATA = Object.freeze({
  name: '',
  email: '',
  password: '',
  avatar: '',
});


function UserForm({ onSubmit, }) {
  const [formData, setFormData] = React.useState(DEFAULT_DATA);


  function _onSubmit() {
    onSubmit(formData);
    setFormData(DEFAULT_DATA);
  }

  function handleChange(event) {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  }


  return (
    <Form>
      <Form.Row>
        <Form.Group
          as={Col}
          required
          controlId="formGridEmail"
        >
          <Form.Label>
            Email
          </Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            name="email"
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group
          as={Col}
          required
          controlId="formGridEmail"
        >
          <Form.Label>
            Nome
          </Form.Label>
          <Form.Control
            type="name"
            placeholder="Nome"
            name="name"
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group
          as={Col}
          required
          controlId="formGridPassword"
        >
          <Form.Label>
            Password
          </Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            name="password"
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group
          required
          as={Col}
          controlId="formGridAddress1"
        >
          <Form.Label>
            Avatar
          </Form.Label>
          <Form.Control
            name="avatar"
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>

      <Button
        variant="primary"
        onClick={_onSubmit}
      >
        Salvar
      </Button>
    </Form>
  );
}

export default UserForm;
